import { render, staticRenderFns } from "./MessageResponse.vue?vue&type=template&id=b430a952&scoped=true&"
import script from "./message-response.ts?vue&type=script&lang=ts&"
export * from "./message-response.ts?vue&type=script&lang=ts&"
import style0 from "./MessageResponse.vue?vue&type=style&index=0&id=b430a952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b430a952",
  null
  
)

export default component.exports